<form [formGroup]="droneForm">
    <div class="field-container">
        @if (updateDrone) {
            <mat-form-field>
                <mat-label>Serial Number</mat-label>
                <input matInput #input maxlength="100" formControlName="serialNumber"/>
            </mat-form-field><br>
        }
        <app-drone-models-component (messageEvent)="receiveMessage($event)"/>
        <mat-form-field>
            <mat-label>Manufacture Date</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" formControlName="manufactureDate">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
</form>